var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switch-container",class:{ 'switch-container--satellite': _vm.dark }},[_c('v-switch',{attrs:{"input-value":_vm.localValue,"label":_vm.localValue ? _vm.onText : _vm.offText,"dark":_vm.dark,"color":_vm.dark ? undefined : 'primary',"hide-details":""},on:{"change":_vm.onSwitchChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }